import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ManageVansComponent } from '../../components/manage-vans/manage-vans.component';


const routes: Route[] = [{
  path: 'manageVans',
  component: ManageVansComponent,
  children: [
    {path: 'create', component: ManageVansComponent, outlet: 'side'}
  ]
}];

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ManageVansComponent],
  exports:[ManageVansComponent]
})
export class ManageVansModule { }
